var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEarnings(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "earnings",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 33 25",
    style: {
      enableBackground: "new 0 0 33 25"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "bar5",
    d: "M30.5,0L30.5,0C31.9,0,33,1.1,33,2.5v20c0,1.4-1.1,2.5-2.5,2.5l0,0c-1.4,0-2.5-1.1-2.5-2.5v-20 C28,1.1,29.1,0,30.5,0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "bar4",
    d: "M23.5,5L23.5,5C24.9,5,26,6.1,26,7.5v15c0,1.4-1.1,2.5-2.5,2.5l0,0c-1.4,0-2.5-1.1-2.5-2.5v-15 C21,6.1,22.1,5,23.5,5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "bar3",
    d: "M16.5,10L16.5,10c1.4,0,2.5,1.1,2.5,2.5v10c0,1.4-1.1,2.5-2.5,2.5l0,0c-1.4,0-2.5-1.1-2.5-2.5v-10 C14,11.1,15.1,10,16.5,10z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "bar2",
    d: "M9.5,15L9.5,15c1.4,0,2.5,1.1,2.5,2.5v5c0,1.4-1.1,2.5-2.5,2.5l0,0C8.1,25,7,23.9,7,22.5v-5 C7,16.1,8.1,15,9.5,15z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "bar1",
    d: "M2.5,20L2.5,20C3.9,20,5,21.1,5,22.5l0,0C5,23.9,3.9,25,2.5,25l0,0C1.1,25,0,23.9,0,22.5l0,0 C0,21.1,1.1,20,2.5,20z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEarnings);
export default __webpack_public_path__ + "static/media/earnings.3d4fc1c432fce088bea85999fc47fafd.svg";
export { ForwardRef as ReactComponent };